// extracted by mini-css-extract-plugin
export var container = "aspect-ratio-module--container--QZjmZ";